<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <div class="btn-box">
          <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin: 0 5px;">打卡时间</span>
          <el-date-picker v-model="timeValue" size="small" type="datetimerange"
                          :picker-options="pickerOptions2" range-separator="至"
                          start-placeholder="开始时间" end-placeholder="结束时间"
                          align="right" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
<!--        <button-add :pathName="addDataParkHonor"/>-->
        <!--<button-delete @deleteSelection="deleteSelection" />-->
      </div>
<!--      <div class="btn-box">-->
<!--        <input-select selectTitle="上班打卡结果" selectKey="checkInResult" selectWidth="165px" :selectData="checkInResultList" @search="search" style="margin-right: 10px;"/>-->
<!--        <input-select selectTitle="下班打卡结果" selectKey="checkOutResult" selectWidth="165px" :selectData="checkOutResultList" @search="search" style="margin-right: 10px;"/>-->
<!--      </div>-->
      <div style="display: flex;justify-content: space-between;">
        <input-search placeholder="姓名/手机号" @search="searchKey" />
<!--        <button-export-->
<!--          style="margin-left: 5px"-->
<!--          :href="exportUrl"-->
<!--          download="download.xls"-->
<!--          :beforeDownload="beforeDownload"-->
<!--          value="导出"/>-->
      </div>
    </div>
    <table-main :selection="false" :hasOperation="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/AttendancePoint'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nAlert, nError, nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb
    },
    name: 'attendance-punch-record-manage',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧考勤',
          name: 'attendance-department-manage'
        }, {
          value: '打卡记录'
        }],
        exportUrl: '',
        timeValue: [],
        pickerOptions2: {
          shortcuts: [{
            text: '近一年',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(end.getTime() - 3600 * 1000 * 24 * 365)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '近三年',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(end.getTime() - 3600 * 1000 * 24 * 365 * 3)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '近五年',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(end.getTime() - 3600 * 1000 * 24 * 365 * 5)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        operationArr: ['modify', 'delete'],

        checkInResultList: [
          {key: '', label: '全部'},
          {key: '1', label: '正常'},
          {key: '2', label: '迟到'},
          {key: '3', label: '早退'},
          {key: '4', label: '缺卡'},
          {key: '5', label: '请假'},
          {key: '6', label: '调休'},
          {key: '7', label: '旷工'},
        ],

        checkOutResultList: [
          {key: '', label: '全部'},
          {key: '1', label: '正常'},
          {key: '2', label: '迟到'},
          {key: '3', label: '早退'},
          {key: '4', label: '缺卡'},
          {key: '5', label: '请假'},
          {key: '6', label: '调休'},
          {key: '7', label: '旷工'},
        ],

        tableHead: [{
          prop: 'personName',
          label: '姓名'
        }, {
          prop: 'phone',
          label: '手机号'
        }, {
          prop: 'deptName',
          label: '所属部门'
        }, {
          prop: 'positionName',
          label: '所在岗位'
        }, {
          prop: 'enterpriseName',
          label: '所属住户'
        }, {
          prop: 'snapUrl',
          label: '人脸抓拍',
          isPreviewPic: true
        }, {
          prop: 'openTime',
          label: '打卡时间'
        }],
        tableData: [],
        total: 0,
        selectionArr: [],
        requestData: {
          checkInResult: '',
          checkOutResult: '',
          searchKey: '',
          pageSize: 10,
          pageNum: 1,
          startTime: '',
          endTime: ''
        },
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getPage()
    },
    activated() {
      this.getPage()
    },
    methods: {
      beforeDownload () {
        this.exportUrl = `${api.exportAttendanceRecord}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&startTime=${this.requestData.startTime}&endTime=${this.requestData.endTime}`
      },
      getPage () {
        if (this.timeValue) {
          this.requestData.startTime = this.timeValue[0] || ''
          this.requestData.endTime = this.timeValue[1] || ''
        } else {
          this.requestData.startTime = ''
          this.requestData.endTime = ''
        }
        this.$axios.post(api.getClockRecordPage, this.requestData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {
                this.checkInResultList.map(checkItem => {
                  if (checkItem.key === v.checkInResult) {
                    v.checkInResultText = checkItem.label
                  }
                })
                this.checkOutResultList.map(checkItem => {
                  if (checkItem.key === v.checkOutResult) {
                    v.checkOutResultText = checkItem.label
                  }
                })
              })
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取数据失败'))
      },
      search (v) {
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.requestData.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.requestData.pageNum = data[0]
        this.requestData.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
    },
    watch: {
      timeValue (val) {
        this.getPage()
      }
    }
  }
</script>

<style scoped>
  .form-line {
    width: 420px;
    margin: 20px auto;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .red {
    color: red;
  }
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>



// WEBPACK FOOTER //
// src/view/WorkAttendance/AttendancePunchRecordManage/AttendancepPunchRecordManage.vue